var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoaded),expression:"!isLoaded"}]},[_vm._v(" Redirecting ")]),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}]},[_vm._v(" Could not redirect, source does not exists ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }